import { render, staticRenderFns } from "./RegisteredAgentLayout.vue?vue&type=template&id=0f6735c6&"
import script from "./RegisteredAgentLayout.vue?vue&type=script&lang=js&"
export * from "./RegisteredAgentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports